import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SavableFormLabel(props) {
  const [showResult, setShowResult] = useState(true);
  const [failed, setFailed] = useState(true);
  useEffect(() => {
    if (props.isSaving) {
      setShowResult(false);
      setFailed(false);
      return () => {};
    } else {
      const resultTimeout = setTimeout(() => setShowResult(true), 100);
      const failedTimeout = setTimeout(() => setFailed(true), 2000);
      return () => {
        clearTimeout(resultTimeout);
        clearTimeout(failedTimeout);
      };
    }
  }, [props.isSaving]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(UIFormLabel, {
        "data-test-id": "form-label",
        required: props.isRequired,
        children: [props.label, props.helpText ? /*#__PURE__*/_jsx(UIHelpIcon, {
          className: "m-left-2",
          tooltipPlacement: "bottom",
          title: props.helpText
        }) : null]
      })
    }), /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      direction: "row",
      justify: "end",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        className: "savable-label-loading-spinner",
        "data-test-id": "loading-spinner",
        failed: failed,
        showResult: showResult,
        size: "xs"
      })
    })]
  });
}
SavableFormLabel.propTypes = {
  helpText: PropTypes.node,
  isRequired: PropTypes.bool,
  isSaving: PropTypes.bool,
  label: PropTypes.node.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
SavableFormLabel.defaultProps = {
  helpText: null,
  isRequired: false,
  isSaving: false
};
export default SavableFormLabel;